import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { useGetSelectedLabelProviderIds } from '../../wallet/modals/wallet-registration/hooks/use-get-selected-label-providerIds';
import { EMAIL_REQUIRED_CARRIERS } from '../../pages/settings/ship-from-locations/constants';

export const presetOrRateBrowserRequiresEmail = (selectedShipFrom, labelProviderId) => {
  if (!EMAIL_REQUIRED_CARRIERS.includes(labelProviderId)) {
    return false;
  }
  if (selectedShipFrom?.originAddress?.email && selectedShipFrom?.returnAddress?.email) {
    return false;
  }
  return true;
};

export const useExistingShipFromRequiresEmail = (selectedShipFroms, selectedCarrier, showErrors = true) => {
  const shipFromIdsWithoutEmail = selectedShipFroms
    ?.filter((sf) => !sf?.originAddress?.email || !sf?.returnAddress?.email)
    .map((sf) => sf.shipFromId);
  const selectedFulfillmentPlanIds = useSelector(Global.selectSelectedOrdersIds);
  const fulfillmentPlans =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlansByIds(state, {
        fulfillmentPlanIds: selectedFulfillmentPlanIds,
      }),
    ) || [];
  const ffpIdsWithoutEmail = fulfillmentPlans
    .filter((ffp) => shipFromIdsWithoutEmail.includes(ffp.labelConfiguration?.shipFromId))
    .map((ffp) => ffp.fulfillmentPlanId);

  const sellerLabelProviderIds = useSelector((state) => {
    return ffpIdsWithoutEmail.map((fulfillmentPlanId) =>
      Global.selectEntitiesFulfillmentPlanSellerLabelProviderID(state, {
        fulfillmentPlanId,
      }),
    );
  });

  const selectedProviderIds = useGetSelectedLabelProviderIds(sellerLabelProviderIds);

  if (!showErrors) {
    return false;
  }
  if (selectedCarrier) {
    return presetOrRateBrowserRequiresEmail(selectedShipFroms, selectedCarrier);
  }
  return selectedProviderIds.some((carrier) => EMAIL_REQUIRED_CARRIERS.includes(carrier));
};
